var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c("b-row", { staticClass: "justify-content-md-center my-4" }, [
        _vm._v(
          " Cliquez sur une ligne du tableau pour personnaliser le message "
        ),
      ]),
      _c("b-table", {
        staticClass: "pointer-table",
        attrs: {
          fields: _vm.tableColumns,
          items: _vm.tableData,
          stacked: "md",
          striped: "",
        },
        on: {
          "row-clicked": (item) =>
            _vm.$set(item, "_showDetails", !item._showDetails),
        },
        scopedSlots: _vm._u([
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c("text-editor", {
                  attrs: { name: "texteditor" + row.index },
                  model: {
                    value: row.item.messagePerso,
                    callback: function ($$v) {
                      _vm.$set(row.item, "messagePerso", $$v)
                    },
                    expression: "row.item.messagePerso",
                  },
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }